export const RATE_LIST_ACTION = "RATE_ACTION";
export const RATE_LIST_SUCCESS = "RATE_LIST_SUCCESS";
export const RATE_LIST_FAIL = "RATE_LIST_FAIL";
export const RATE_DETAIL_ACTION = "RATE_DETAIL_ACTION";
export const RATE_DETAIL_SUCCESS = "RATE_DETAIL_SUCCESS";
export const RATE_DETAIL_FAIL = "RATE_DETAIL_FAIL";
export const RATE_FAIL = "RATE_FAIL";
export const RATE_SAVE_SUCCESS = "RATE_SAVE_SUCCESS";
export const RATE_SAVE_ACTION = "RATE_SAVE_ACTION";
export const RATE_SAVE_FAIL = "RATE_SAVE_FAIL";

export const RATE_CREATE_TRANSLATE_ACTION = "RATE_CREATE_TRANSLATE_ACTION";
export const RATE_CREATE_TRANSLATE_SUCCESS = "RATE_CREATE_TRANSLATE_SUCCESS";

export const RATE_UPDATE_TRANSLATE_ACTION = "RATE_UPDATE_TRANSLATE_ACTION";
export const RATE_UPDATE_TRANSLATE_SUCCESS = "RATE_UPDATE_TRANSLATE_SUCCESS";

export const RATE_DELETE_TRANSLATE_ACTION = "RATE_DELETE_TRANSLATE_ACTION";
export const RATE_DELETE_TRANSLATE_SUCCESS = "RATE_DELETE_TRANSLATE_SUCCESS";

export const RATE_SORT_ACTION = "RATE_SORT_ACTION";
export const RATE_SORT_SUCCESS = "RATE_SORT_SUCCESS";

export const RATE_SYNC_ALL_HOTELS_ACTION = "RATE_SYNC_ALL_HOTELS_ACTION";
export const RATE_SYNC_ALL_HOTELS_SUCCESS = "RATE_SYNC_ALL_HOTELS_SUCCESS"



export const RATE_SYNC_RATES_ACTION = "RATE_SYNC_RATES_ACTION";
export const RATE_SYNC_RATES_SUCCESS = "RATE_SYNC_RATES_SUCCESS"

export const RATE_LIST_BY_HOTELS_ACTION = "RATE_LIST_BY_HOTELS_ACTION";
export const RATE_LIST_BY_HOTELS_SUCCESS = "RATE_LIST_BY_HOTELS_SUCCESS";
export const RATE_LIST_BY_HOTELS_FAIL = "RATE_LIST_BY_HOTELS_FAIL";

export const CANCEL_POLICY_SYNC_ACTION = "CANCEL_POLICY_SYNC_ACTION";
export const CANCEL_POLICY_SYNC_SUCCESS = "CANCEL_POLICY_SYNC_SUCCESS"
export const CANCEL_POLICY_UPDATE_ACTION = "CANCEL_POLICY_UPDATE_ACTION";
export const CANCEL_POLICY_UPDATE_SUCCESS = "CANCEL_POLICY_UPDATE_SUCCESS";
export const CANCEL_POLICY_FAIL = "CANCEL_POLICY_FAIL";

export const RATE_USAGE_STATUS_ACTION = "RATE_USAGE_STATUS_ACTION";
export const RATE_USAGE_STATUS_SUCCESS = "RATE_USAGE_STATUS_SUCCESS";

export const RATE_UPDATE_ACTIVE_ACTION = "RATE_UPDATE_ACTIVE_ACTION";
export const RATE_UPDATE_ACTIVE_SUCCESS = "RATE_UPDATE_ACTIVE_SUCCESS";

export const SYNC_RATE_LANGUAGE_ACTION = "SYNC_RATE_LANGUAGE_ACTION";
export const SYNC_RATE_LANGUAGE_SUCCESS = "SYNC_RATE_LANGUAGE_SUCCESS";
export const SYNC_RATE_LANGUAGE_FAIL = "SYNC_RATE_LANGUAGE_FAIL";

export const RATE_UPDATE_EXTEND_ACTION = "RATE_UPDATE_EXTEND_ACTION";
export const RATE_UPDATE_EXTEND_SUCCESS = "RATE_UPDATE_EXTEND_SUCCESS";

export const RATE_BEACH_VILLA_CREATE_ACTION = "RATE_BEACH_VILLA_CREATE_ACTION";
export const RATE_BEACH_VILLA_CREATE_SUCCESS = "RATE_BEACH_VILLA_CREATE_SUCCESS";

export const PRICE_CONFIG_LIST_ACTION = "PRICE_CONFIG_LIST_ACTION";
export const PRICE_CONFIG_LIST_SUCCESS = "PRICE_CONFIG_LIST_SUCCESS";

export const PRICE_CONFIG_BEACH_VILLA_CREATE_ACTION = "PRICE_CONFIG_BEACH_VILLA_CREATE_ACTION";
export const PRICE_CONFIG_BEACH_VILLA_CREATE_SUCCESS = "PRICE_CONFIG_BEACH_VILLA_CREATE_SUCCESS";

export const PRICE_CONFIG_BEACH_VILLA_UPDATE_ACTION = "PRICE_CONFIG_BEACH_VILLA_UPDATE_ACTION";
export const PRICE_CONFIG_BEACH_VILLA_UPDATE_SUCCESS = "PRICE_CONFIG_BEACH_VILLA_UPDATE_SUCCESS";
